import request from './request';

const merchantService = {
  getAll: (params) =>
    request.get('dashboard/admin/merchants/paginate', { params }),
  getById: (uuid, params) =>
    request.get(`dashboard/admin/merchants/${uuid}`, { params }),
  create: (data) =>
    request.post('dashboard/admin/merchants', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  update: (uuid, data) =>
    request.post(`dashboard/admin/merchants/${uuid}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  delete: (uuid) => request.delete(`dashboard/admin/merchants/${uuid}`),
  statusChange: (uuid, data) =>
    request.post(`dashboard/admin/merchants/${uuid}/status/change`, data),
};

export default merchantService;
